<template>
  <form autocomplete="off" v-on:submit.prevent="submit(form)" class="form">
    <div class="flex form-row">
      <div class="col-6">
        <label for="first_name">First Name <span>*</span></label>
        <input id="first_name" type="text" placeholder="First Name" name="first_name"
               v-model="form.first_name" v-validate="'required|max:100'">
        <span v-if="errors.has('first_name')">{{ errors.first('first_name') }}</span>
      </div>
      <div class="col-6">
        <label for="last_name">Last Name <span>*</span></label>
        <input id="last_name" type="text" placeholder="Last Name" name="last_name" v-model="form.last_name"
               v-validate="'required|max:100'">
        <span v-if="errors.has('last_name')">{{ errors.first('last_name') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-6">
        <label for="job_title">Job Title <span>*</span></label>
        <input id="job_title" type="text" placeholder="Job Title" name="job_title" v-model="form.job_title"
               v-validate="'required|max:100'">
        <span v-if="errors.has('job_title')">{{ errors.first('job_title') }}</span>
      </div>
      <div class="col-6">
        <label for="phone">Phone <span>*</span></label>
        <input id="phone" type="text" placeholder="Phone" name="phone" v-model="form.phone"
               v-validate="'required|max:15'">
        <span v-if="errors.has('phone')">{{ errors.first('phone') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-8">
        <label for="institution_name">School/Institution <span>*</span></label>
        <input id="institution_name" type="text" placeholder="Institution Name" name="institution_name"
               v-model="form.institution_name" v-validate="'required|max:100'" data-vv-as="institution name">
        <span v-if="errors.has('institution_name')">{{ errors.first('institution_name') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-6">
        <label for="institution_type">Institution Type <span>*</span></label>
        <div class="inline-block relative w-full">
          <select ref="institution_type" id="institution_type" type="text" name="institution_type" v-model="form.institution_type" v-validate="'required'" data-vv-as="institution type">
            <option disabled></option>
            <option v-for="(institutionType, key, index) of institutionTypes" :value="key" :key="index">{{ institutionType }}</option>
          </select>
          <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
          </div>
        </div>
        <span v-if="errors.has('institution_type')">{{ errors.first('institution_type') }}</span>
      </div>
      <div class="col-6">
        <label for="institution_type_other">Other - Institution Type <span v-if="form.institution_type === '3'">*</span></label>
        <input id="institution_type_other" type="text" placeholder="Other Institution Type" name="institution_type_other" v-model="form.institution_type_other"
               :disabled="form.institution_type !== '3'" v-validate="'required_if:institution_type,3|max:100'" data-vv-as="other">
        <span v-if="errors.has('institution_type_other')">{{ errors.first('institution_type_other') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-8">
        <label for="address1">Street Address <span>*</span></label>
        <input id="address1" type="text" placeholder="Address" name="address1" v-model="form.address1"
               v-validate="'required|max:100'">
        <span v-if="errors.has('address1')">{{ errors.first('address1') }}</span>
      </div>
      <div class="col-4">
        <label for="address2">Address 2</label>
        <input id="address2" type="text" placeholder="Bldg/Suite" name="address2" v-validate="'max:100'" v-model="form.address2">
        <span v-if="errors.has('address2')">{{ errors.first('address2') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-4">
        <label for="city">City <span>*</span></label>
        <input id="city" type="text" placeholder="City" name="city" v-model="form.city"
               v-validate="'required|max:100'">
        <span v-if="errors.has('city')">{{ errors.first('city') }}</span>
      </div>
      <div class="col-3">
        <label for="country">Country <span>*</span></label>
        <div class="inline-block relative w-full">
          <select id="country" type="text" name="country" v-model="form.country" v-validate="'required'">
            <option disabled></option>
            <option v-for="(country, key, index) of countries" :value="key" :key="index">{{ country }}</option>
          </select>
          <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
          </div>
        </div>
        <span v-if="errors.has('country')">{{ errors.first('country') }}</span>
      </div>
      <div class="col-2">
        <label for="state">State/Province <span>*</span></label>
        <div class="inline-block relative w-full">
          <select id="state" type="text" name="state" v-model="form.state" v-validate="'required|length:2'">
            <option disabled></option>
            <option v-if="form.country !== 'CA'" v-for="(state, key, index) of states" :value="state" :key="index">{{ state }}</option>
            <option v-if="form.country === 'CA'" v-for="(state, key, index) of provinces" :value="state" :key="index">{{ state }}</option>
          </select>
          <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
          </div>
        </div>
        <span v-if="errors.has('state')">{{ errors.first('state') }}</span>
      </div>
      <div class="col-3">
        <label for="zip">Zip/Postal Code <span>*</span></label>
        <input id="zip" type="text" placeholder="Zip/Postal Code" name="zip" v-model="form.zip"
               v-validate="'required'" data-vv-as="zip/postal code">
        <span v-if="errors.has('zip')">{{ errors.first('zip') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-6">
        <label for="email">Email Address <span>*</span></label>
        <input id="email" type="text" placeholder="Email Address" name="email"
               v-model="form.email" v-validate="'required|email|max:100'">
        <span v-if="errors.has('email')">{{ errors.first('email') }}</span>
      </div>
    </div>
    <div class="flex form-row pt-3 mb-0">
      <div class="col-4">
        <vue-recaptcha
          name="recaptcha"
          ref="recaptcha"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
          size="normal"
          sitekey="6LfPhpEUAAAAAJAGW-4YZYvuBzPg98qeYkKq8QJD"
          v-model="form.recaptcha"
          v-validate="'required|min:1'">
        </vue-recaptcha>
        <span v-if="errors.has('recaptcha')">{{ errors.first('recaptcha') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <input id="password" type="hidden" name="password" placeholder="Password"
             v-model="form.password" v-validate="'required|min:6'" ref="password">
      <input id="password_confirmation" type="hidden" name="password_confirmation" placeholder="Password"
             v-model="form.password_confirmation" v-validate="'required|confirmed:password'" data-vv-as="password">
      <button class="body-8 btn" :disabled="pending || errors.any()">Submit</button>
    </div>
  </form>
</template>

<script>
  import { usStates } from '@/common/utils/us-states';
  import { caProvinces } from "@/common/utils/ca-provinces";
  import { countries } from "@/common/utils/countries";
  import { institutionTypes } from "@/common/utils/institution-types";
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: 'RegisterForm',
    components: {
      'vue-recaptcha': VueRecaptcha
    },
    props: ['pending'],
    data: function () {

      return {
        form: {
          institution_name: null,
          institution_type: null,
          institution_type_other: null,
          first_name: null,
          last_name: null,
          job_title: null,
          phone: null,
          address1: null,
          address2: null,
          city: null,
          state: null,
          zip: null,
          country: null,
          email: null,
          password: process.env.VUE_APP_GENERIC_PASSWORD,
          password_confirmation: process.env.VUE_APP_GENERIC_PASSWORD,
          recaptcha: null,
        },
        states: usStates,
        provinces: caProvinces,
        countries: countries,
        institutionTypes: institutionTypes,
      }
    },
    methods: {
      submit() {
        if(this.form.institution_type !== '3') {
          this.form.institution_type_other = null;
        }
        this.$validator.validateAll().then((valid) => {
          if (valid) {
            this.$refs.recaptcha.reset();
            this.$emit('submit', this.form);
          }
        });
      },
      onCaptchaVerified(recaptchaToken) {
        this.form.recaptcha = recaptchaToken;
      },
      onCaptchaExpired: function () {
        this.$refs.recaptcha.reset();
      }
    }
  };
</script>
